<template>
  <v-pagination
    outlined
    style="background: #E5E5E5;"
    :color="$theme.primary"
    total-visible="7"
    v-model="get_banners_filtros.page"
    :length="get_banners.totalPages"
    @input="setPage($event)"
  ></v-pagination>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["get_banners", "get_banners_filtros"])
  },
  methods: {
    ...mapActions(["listar_banners"]),
    setPage(page) {
      if (page) {
        console.log("page", page);
        this.get_banners_filtros.page = page;
        this.listar_banners();
      }
    }
  }
};
</script>
